import { XMLParser } from 'fast-xml-parser';
export const parseXmlData = async _ref => {
  let {
    fullXmlFilePath
  } = _ref;
  try {
    const response = await fetch(fullXmlFilePath);
    if (!response.ok) {
      throw new Error(`XML Fetch HTTP error! status: ${response.status}`);
    }
    const xmlData = await response.text();
    return convertXmlToJson(xmlData);
  } catch (error) {
    console.error('Failed to load XML data for static tool', error);
    return null;
  }
};
export const convertXmlToJson = xmlData => {
  if (!xmlData || xmlData.length === 0) {
    return null;
  }
  try {
    const xmlParser = new XMLParser({
      ignoreDeclaration: true,
      parseTagValue: false
    });
    const xmlDataInJson = xmlParser.parse(xmlData);
    return xmlDataInJson.dataset?.record || null;
  } catch (error) {
    console.error('Failed to parse XML data:', error);
    return null;
  }
};